import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsGridTile extends SnModel {
  @Expose()
  public label: string;

  @Expose()
  public user: any;

  @Expose()
  public createdTimestamp: Date;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
